export const shippingProviders = {
    0: 'one of our shipping partners',
    1: 'Arta',
    2: 'Team World Wide',
    3: 'ThePackengers',
    4: 'National Logistic Services',
    // This is a test id. If you see this on a real auction, hoo boy.
    5: 'ThePackengers',
    // _end test ids
    6: 'Shipping Saint',
} as const;

export type ShippingProviderId = keyof typeof shippingProviders;
